var LD_EN = (function(){ try { return ((document.documentElement.getAttribute('lang')||'').toLowerCase().indexOf('en') === 0); } catch (e) { return false; } })();
function pdQuizText(fr,en,de,nl) { var lang=(document.documentElement.lang||'fr').split('-')[0];return lang==='de'?de:lang==='nl'?nl:lang==='en'?en:fr; }

/* =========================================================
   PANDRUM — LowDesign Quiz "Aide au choix"
   FIX 5 — Modal vanilla, 3 questions, recommandation produit.
   ========================================================= */
(function() {
  'use strict';

  function pandrumMarketQuizData() {
    try {
      var dataEl = document.getElementById('pandrum-quiz-market-data');
      return dataEl ? JSON.parse(dataEl.textContent) : {};
    } catch (e) { return {}; }
  }
  function pandrumQuizPrice(rec) {
    var data = pandrumMarketQuizData();
    var key = rec.handle.replace('handpan-9-10-12-notes-re-mineur-kurd-mandala','handpan-mandala-9-10-12-notes-re-mineur-kurd') + '|' + rec.notes + '|' + rec.hz;
    return (data.prices && data.prices[key]) || pdQuizText('Voir le prix sur la fiche produit','See current price on the product page','Aktuellen Preis auf der Produktseite ansehen','Bekijk de actuele prijs op de productpagina');
  }
  function pandrumQuizRoot() {
    var data = pandrumMarketQuizData();
    return (data.root || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/en/').replace(/\/$/, '');
  }


  /* =========================================================
     TABLE DES RECOMMANDATIONS PANDRUM
     Handles réels du catalogue pandrum.fr (récupérés via products.json).
     Les valeurs `notes` et `hz` correspondent au format des options
     Shopify (matching regex insensible à la casse + ouvert sur la fin
     pour supporter "9 notes - Débutant" / "432 Hz - Méditation").
     ========================================================= */
  var QUIZ_RECOMMENDATIONS = {
    beginner_low: {
      handle: 'acheter-handpan',
      label: (pdQuizText('Handpan Ré mineur · 9 notes','Handpan D Minor · 9 notes',"Handpan D-Moll · 9 Töne","Handpan D-mineur · 9 tonen")),
      notes: '9 notes',
      hz: '432 Hz',
      price: (pdQuizText('279,90 € (au lieu de 454,90 €)','',"","")),
      image: '',
      note: (pdQuizText('Best-seller — idéal premier handpan, accord apaisant.','Best seller — ideal first handpan, soothing scale.',"Ein Einstieg in die Welt der Handpan.","Een kennismaking met de handpan."))
    },
    beginner_mid: {
      handle: 'acheter-handpan',
      label: (pdQuizText('Handpan Ré mineur · 10 notes','Handpan D Minor · 10 notes',"Handpan D-Moll · 10 Töne","Handpan D-mineur · 10 tonen")),
      notes: '10 notes',
      hz: '432 Hz',
      price: (pdQuizText('339,90 € (au lieu de 584,90 €)','',"","")),
      image: '',
      note: (pdQuizText('Une note de plus pour explorer davantage de mélodies.','One more note to explore more melodies.',"Ein zusätzlicher Ton für weitere Melodien.","Een extra toon voor meer melodieën."))
    },
    beginner_high: {
      handle: (pdQuizText('handpan-9-10-12-notes-re-mineur-kurd-mandala','handpan-mandala-9-10-12-notes-re-mineur-kurd',"handpan-9-10-12-notes-re-mineur-kurd-mandala","handpan-9-10-12-notes-re-mineur-kurd-mandala")),
      label: (pdQuizText('Handpan Mandala Ré mineur Kurd · 9 notes','Mandala Handpan D Minor Kurd · 9 notes',"Mandala-Handpan D-Moll Kurd · 9 Töne","Mandala-handpan D-mineur Kurd · 9 tonen")),
      notes: '9 notes',
      hz: '432 Hz',
      price: (pdQuizText('349,90 € (au lieu de 454,90 €)','',"","")),
      image: '',
      note: (pdQuizText('Gravure mandala faite main, sonorité premium — durable.','Hand-engraved mandala, premium sound — built to last.',"Mandala-Verzierung und ausdrucksstarker Klang.","Mandala-versiering en een expressieve klank."))
    },
    intermediate_meditation: {
      handle: 'acheter-handpan',
      label: (pdQuizText('Handpan Ré mineur · 12 notes / 432 Hz','Handpan D Minor · 12 notes / 432 Hz',"Handpan D-Moll · 12 Töne / 432 Hz","Handpan D-mineur · 12 tonen / 432 Hz")),
      notes: '12 notes',
      hz: '432 Hz',
      price: (pdQuizText('389,90 € (au lieu de 714,90 €)','',"","")),
      image: '',
      note: (pdQuizText('L\'accordage 432 Hz est plébiscité pour la méditation et le bien-être.','432 Hz tuning is favored for meditation and well-being.',"432 Hz: eine alternative Stimmung zum Entdecken.","432 Hz: een alternatieve stemming om te ontdekken."))
    },
    intermediate_composition: {
      handle: 'acheter-handpan',
      label: (pdQuizText('Handpan Ré mineur · 12 notes / 440 Hz','Handpan D Minor · 12 notes / 440 Hz',"Handpan D-Moll · 12 Töne / 440 Hz","Handpan D-mineur · 12 tonen / 440 Hz")),
      notes: '12 notes',
      hz: '440 Hz',
      price: (pdQuizText('389,90 € (au lieu de 714,90 €)','',"","")),
      image: '',
      note: (pdQuizText('Le 440 Hz se marie avec les instruments classiques pour la composition.','440 Hz blends with classical instruments for composing.',"440 Hz entspricht der verbreiteten Standardstimmung.","440 Hz sluit aan bij de veelgebruikte standaardstemming."))
    },
    expert_high: {
      handle: (pdQuizText('handpan-9-10-12-notes-re-mineur-kurd-mandala','handpan-mandala-9-10-12-notes-re-mineur-kurd',"handpan-9-10-12-notes-re-mineur-kurd-mandala","handpan-9-10-12-notes-re-mineur-kurd-mandala")),
      label: (pdQuizText('Handpan Mandala Ré mineur Kurd · 12 notes','Mandala Handpan D Minor Kurd · 12 notes',"Mandala-Handpan D-Moll Kurd · 12 Töne","Mandala-handpan D-mineur Kurd · 12 tonen")),
      notes: '12 notes',
      hz: '432 Hz',
      price: (pdQuizText('549,90 € (au lieu de 714,90 €)','',"","")),
      image: '',
      note: (pdQuizText('La pièce la plus aboutie — gravure mandala, 12 notes, finition premium.','Our most accomplished piece — mandala engraving, 12 notes, premium finish.',"Mandala-Verzierung, 12 Töne und sorgfältige Verarbeitung.","Mandala-versiering, 12 tonen en een verzorgde afwerking."))
    },
    expert_low_mid: {
      handle: 'acheter-handpan',
      label: (pdQuizText('Handpan Ré mineur · 12 notes','Handpan D Minor · 12 notes',"Handpan D-Moll · 12 Töne","Handpan D-mineur · 12 tonen")),
      notes: '12 notes',
      hz: '432 Hz',
      price: (pdQuizText('389,90 € (au lieu de 714,90 €)','',"","")),
      image: '',
      note: (pdQuizText('Le bon équilibre entre richesse mélodique et budget maîtrisé.','The right balance between melodic range and budget.',"Eine Balance zwischen Tonumfang und Budget.","Een balans tussen toonbereik en budget."))
    }
  };

  /* =========================================================
     Logique de mapping réponses → recommandation
     ========================================================= */
  function getRecommendation(answers) {
    var n = answers.niveau, u = answers.usage, b = answers.budget;
    if (n === 'beginner') {
      if (b === 'high') return QUIZ_RECOMMENDATIONS.beginner_high;
      if (b === 'mid')  return QUIZ_RECOMMENDATIONS.beginner_mid;
      return QUIZ_RECOMMENDATIONS.beginner_low;
    }
    if (n === 'intermediate') {
      if (u === 'composition') return QUIZ_RECOMMENDATIONS.intermediate_composition;
      return QUIZ_RECOMMENDATIONS.intermediate_meditation;
    }
    if (n === 'expert') {
      if (b === 'high') return QUIZ_RECOMMENDATIONS.expert_high;
      return QUIZ_RECOMMENDATIONS.expert_low_mid;
    }
    return QUIZ_RECOMMENDATIONS.beginner_low;
  }

  /* ========================================================= */
  var LS_KEY = 'pandrumQuizSeen';
  var LS_TTL_MS = 24 * 60 * 60 * 1000;

  function markQuizSeen() {
    try { localStorage.setItem(LS_KEY, String(Date.now())); } catch(e) {}
  }
  function isQuizSeen() {
    try {
      var v = localStorage.getItem(LS_KEY);
      if (!v) return false;
      var ts = parseInt(v, 10);
      if (!ts || isNaN(ts)) return false;
      return (Date.now() - ts) < LS_TTL_MS;
    } catch(e) { return false; }
  }

  /* ========================================================= */
  document.querySelectorAll('.lowdesign-top').forEach(function(root) {
    var modal = root.querySelector('[data-lds-quiz]');
    if (!modal) return;

    var currentHandle = (root.getAttribute('data-product-handle') || '').toLowerCase();
    var productTitle  = root.getAttribute('data-product-title') || '';

    /* ----- 1) Inject the trigger button just above the color picker -----
       Le picker est rendu par Fullstack et marqué `--color` par transformVariants()
       dans lowdesign-top.js. On attend que la classe apparaisse, puis on insère. */
    var trigger = null;
    function ensureTrigger() {
      if (trigger && document.body.contains(trigger)) return;
      var colorOption = root.querySelector('.variant-picker__option--color');
      var anchor = colorOption || root.querySelector('.ldt-variants-wrapper');
      if (!anchor) return;
      trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'lds-quiz-trigger';
      trigger.setAttribute('data-lds-quiz-trigger', '');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', modal.id);
      trigger.innerHTML = '<span class="lds-quiz-trigger__icon" aria-hidden="true">✨</span>' +
                          (pdQuizText('<span class="lds-quiz-trigger__text">Pas sûr du modèle&nbsp;? Aide au choix en 30 secondes</span>','<span class="lds-quiz-trigger__text">Not sure which model? Find yours in 30 seconds</span>',"<span class=\"lds-quiz-trigger__text\">Welches Modell passt zu Ihnen? Finden Sie es in 30 Sekunden</span>","<span class=\"lds-quiz-trigger__text\">Welk model past bij je? Ontdek het in 30 seconden</span>")) +
                          '<span class="lds-quiz-trigger__arrow" aria-hidden="true">→</span>';
      trigger.addEventListener('click', openModal);
      if (colorOption && colorOption.parentNode) {
        colorOption.parentNode.insertBefore(trigger, colorOption);
      } else {
        anchor.insertBefore(trigger, anchor.firstChild);
      }
    }
    ensureTrigger();
    // Re-essaye après que transformVariants() ait marqué la couleur
    setTimeout(ensureTrigger, 60);
    setTimeout(ensureTrigger, 300);
    setTimeout(ensureTrigger, 1200);

    // Si Fullstack/Shopify reconstruit le variant-picker, ré-injecte le trigger
    if ('MutationObserver' in window) {
      var pickerForObs = root.querySelector('variant-picker') || root.querySelector('.ldt-variants-wrapper');
      if (pickerForObs) {
        var triggerMo = new MutationObserver(function() { ensureTrigger(); });
        triggerMo.observe(pickerForObs, { childList: true, subtree: true });
      }
    }

    /* ----- 2) Modal logic ----- */
    var answers = { niveau: null, usage: null, budget: null };
    var stepOrder = ['1', '2', '3'];
    var currentStep = '1';
    var quizStarted = false;
    var lastFocused = null;

    function getStepEl(name) {
      return modal.querySelector('[data-lds-quiz-step="' + name + '"]');
    }

    function showStep(name) {
      modal.querySelectorAll('[data-lds-quiz-step]').forEach(function(s) { s.hidden = true; });
      var el = getStepEl(name);
      if (el) {
        el.hidden = false;
        currentStep = name;
        // focus first interactive
        var firstBtn = el.querySelector('button:not([hidden]):not([disabled])');
        if (firstBtn) {
          try { firstBtn.focus(); } catch(e) {}
        }
      }
    }

    function resetQuiz() {
      answers = { niveau: null, usage: null, budget: null };
      quizStarted = false;
      modal.querySelectorAll('.lds-quiz__option.is-selected').forEach(function(b) { b.classList.remove('is-selected'); });
      showStep('1');
    }

    function openModal() {
      lastFocused = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('lds-quiz-open');
      requestAnimationFrame(function() { modal.classList.add('is-open'); });
      resetQuiz();
      markQuizSeen();
      document.addEventListener('keydown', onKeydown, true);
    }

    function doClose() {
      modal.classList.remove('is-open');
      document.removeEventListener('keydown', onKeydown, true);
      // Wait for fade-out
      setTimeout(function() {
        modal.hidden = true;
        document.body.classList.remove('lds-quiz-open');
        if (lastFocused && typeof lastFocused.focus === 'function') {
          try { lastFocused.focus(); } catch(e) {}
        }
        // Visual reset for next open
        answers = { niveau: null, usage: null, budget: null };
        quizStarted = false;
        modal.querySelectorAll('.lds-quiz__option.is-selected').forEach(function(b) { b.classList.remove('is-selected'); });
        showStep('1');
      }, 220);
    }

    function attemptClose() {
      if (quizStarted && currentStep !== 'result') {
        if (!window.confirm((pdQuizText('Êtes-vous sûr de vouloir quitter le quiz ?','Are you sure you want to leave the quiz?',"Möchten Sie das Quiz wirklich verlassen?","Wil je de keuzehulp echt verlaten?")))) return;
      }
      doClose();
    }

    function onKeydown(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        e.preventDefault();
        attemptClose();
        return;
      }
      if (e.key === 'Tab' || e.keyCode === 9) {
        trapFocus(e);
      }
    }

    function trapFocus(e) {
      var focusables = modal.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])'
      );
      var visible = Array.prototype.filter.call(focusables, function(el) {
        return !el.closest('[hidden]') && el.offsetParent !== null;
      });
      if (!visible.length) return;
      var first = visible[0], last = visible[visible.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }

    function handleAnswer(btn) {
      var key = btn.getAttribute('data-key');
      var value = btn.getAttribute('data-value');
      if (!key || !value) return;
      answers[key] = value;
      quizStarted = true;
      // Visual select
      var siblings = modal.querySelectorAll('.lds-quiz__option[data-key="' + key + '"]');
      siblings.forEach(function(s) { s.classList.remove('is-selected'); });
      btn.classList.add('is-selected');

      // Advance
      var idx = stepOrder.indexOf(currentStep);
      if (idx === -1) return;
      if (idx + 1 < stepOrder.length) {
        // Tiny delay to show selection feedback
        setTimeout(function() { showStep(stepOrder[idx + 1]); }, 180);
      } else {
        setTimeout(showResult, 180);
      }
    }

    function goBack() {
      var idx = stepOrder.indexOf(currentStep);
      if (idx > 0) showStep(stepOrder[idx - 1]);
    }

    function showResult() {
      var rec = getRecommendation(answers);
      if (!rec) rec = QUIZ_RECOMMENDATIONS.beginner_low;

      var nameEl  = modal.querySelector('[data-lds-quiz-result-name]');
      var priceEl = modal.querySelector('[data-lds-quiz-result-price]');
      var noteEl  = modal.querySelector('[data-lds-quiz-result-note]');
      var imgEl   = modal.querySelector('[data-lds-quiz-result-image]');
      var ctaEl   = modal.querySelector('[data-lds-quiz-result-cta]');

      if (nameEl)  nameEl.textContent  = rec.label || '';
      if (priceEl) priceEl.textContent = (LD_EN || !['FR','US'].includes((window.Shopify||{}).country)) ? pandrumQuizPrice(rec) : (rec.price || '');
      if (noteEl)  {
        if (rec.note) { noteEl.textContent = rec.note; noteEl.hidden = false; }
        else { noteEl.textContent = ''; noteEl.hidden = true; }
      }
      if (imgEl) {
        if (rec.image) { imgEl.src = rec.image; imgEl.alt = rec.label || ''; imgEl.hidden = false; }
        else { imgEl.removeAttribute('src'); imgEl.hidden = true; }
      }

      // Cas 1 : recommandation = produit en cours → auto-sélection
      // Cas 2 : autre produit → redirection
      var isSameProduct = !!rec.handle && currentHandle && rec.handle.toLowerCase() === currentHandle;
      if (isSameProduct) {
        // Auto-sélectionne notes + hz dans le picker via le helper exposé
        var applied = false;
        if (typeof root.ldtSelectVariant === 'function') {
          try { applied = root.ldtSelectVariant(rec.notes, rec.hz); } catch(e) {}
        }
        if (ctaEl) {
          ctaEl.textContent = applied ? (pdQuizText('✓ Pré-sélectionné · choisir une couleur','✓ Pre-selected · choose a color',"✓ Vorausgewählt · Farbe wählen","✓ Voorgeselecteerd · kies een kleur")) : (pdQuizText('Voir ce modèle ↓','See this model ↓',"Dieses Modell ansehen ↓","Bekijk dit model ↓"));
          ctaEl.setAttribute('href', '#LowDesignTop-' + (modal.id.replace(/^LdsQuiz-/, '')));
          ctaEl.onclick = function(e) {
            e.preventDefault();
            doClose();
            var form = root.querySelector('.ldt-form-wrapper');
            if (form && form.scrollIntoView) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
          };
        }
        if (noteEl) {
          noteEl.hidden = false;
          noteEl.textContent = applied
            ? (pdQuizText('✓ C\'est exactement ce modèle. Variantes pré-sélectionnées : ','✓ This is exactly the model. Pre-selected options: ',"✓ Das ist genau dieses Modell. Vorausgewählte Optionen: ","✓ Dit is precies dit model. Voorgeselecteerde opties: ")) + rec.notes + ' / ' + rec.hz + (pdQuizText('. Choisissez une couleur.','. Choose a color.',". Wählen Sie eine Farbe.",". Kies een kleur."))
            : (rec.note || '');
        }
      } else if (rec.handle && rec.handle.indexOf('TODO_HANDLE_') !== 0) {
        if (ctaEl) {
          ctaEl.textContent = (pdQuizText('Voir ce modèle →','See this model →',"Dieses Modell ansehen →","Bekijk dit model →"));
          ctaEl.setAttribute('href', (pandrumQuizRoot()) + '/products/' + rec.handle);
          ctaEl.onclick = null;
        }
      } else {
        // Handle non configuré (TODO_HANDLE_xxx) — désactive le CTA gracieusement
        if (ctaEl) {
          ctaEl.textContent = (pdQuizText('Modèle bientôt disponible','Model coming soon',"Modell bald verfügbar","Model binnenkort beschikbaar"));
          ctaEl.setAttribute('href', '#');
          ctaEl.setAttribute('aria-disabled', 'true');
          ctaEl.classList.add('is-disabled');
          ctaEl.onclick = function(e) { e.preventDefault(); };
        }
      }

      showStep('result');
    }

    /* ----- Listeners ----- */
    modal.addEventListener('click', function(e) {
      var t = e.target;
      // Backdrop click
      if (t && t.matches && t.matches('[data-lds-quiz-backdrop]')) {
        attemptClose();
        return;
      }
      // Close button
      if (t.closest && t.closest('[data-lds-quiz-close]')) {
        attemptClose();
        return;
      }
      // Back button
      if (t.closest && t.closest('[data-lds-quiz-back]')) {
        goBack();
        return;
      }
      // Answer
      var answerBtn = t.closest && t.closest('[data-lds-quiz-answer]');
      if (answerBtn) {
        handleAnswer(answerBtn);
        return;
      }
      // Restart
      if (t.closest && t.closest('[data-lds-quiz-restart]')) {
        resetQuiz();
        return;
      }
    });

    // Expose openModal au cas où on voudrait l'ouvrir programmatiquement
    root.ldsQuizOpen = openModal;
  });
})();
